module.exports = __webpack_public_path__ + "img/DashBoard1.fd829992.jpg";